var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm.uniqueDates.length > 1
        ? [
            _c("h4", { staticClass: "headingLevel mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.getTranslation(
                    "licence-configurator",
                    "subscription_options"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-form-radio",
              {
                staticClass: "mb-3 mt-4",
                attrs: {
                  id: "lease_custom_" + _vm.product.id,
                  name: "configure_period_" + _vm.product.id,
                  value: "1",
                },
                on: {
                  change: function ($event) {
                    return _vm.setSeparate()
                  },
                },
                model: {
                  value: _vm.leaseOptions.selectedOption,
                  callback: function ($$v) {
                    _vm.$set(_vm.leaseOptions, "selectedOption", $$v)
                  },
                  expression: "leaseOptions.selectedOption",
                },
              },
              [
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getTranslation(
                        "licence-configurator",
                        "keep_subscriptions_separate"
                      )
                    )
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-radio",
              {
                staticClass: "mb-3 mt-4",
                attrs: {
                  id: "lease_merge_" + _vm.product.id,
                  name: "configure_period_" + _vm.product.id,
                  value: "2",
                },
                on: {
                  change: function ($event) {
                    return _vm.mergeSubscriptions()
                  },
                },
                model: {
                  value: _vm.leaseOptions.selectedOption,
                  callback: function ($$v) {
                    _vm.$set(_vm.leaseOptions, "selectedOption", $$v)
                  },
                  expression: "leaseOptions.selectedOption",
                },
              },
              [
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getTranslation(
                        "licence-configurator",
                        "merge_subscriptions"
                      )
                    )
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.leaseUniqueDates[_vm.product.id], function (date) {
              return _c(
                "div",
                {
                  key: date,
                  staticClass:
                    "custom-control custom-checkbox b-custom-control-lg mb-2",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "checkbox",
                      id: "lease_merge_" + _vm.product.id + "_" + date,
                      name: "lease_merge_" + _vm.product.id + "_" + date,
                      disabled:
                        _vm.leaseOptions.selectedOption != 2 ||
                        _vm.uniqueDates.includes(date),
                    },
                    domProps: {
                      value: date,
                      checked:
                        _vm.leaseOptions.dates &&
                        _vm.leaseOptions.dates.includes(date) &&
                        _vm.leaseOptions.selectedOption === 2,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addLeaseMerge($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label d-flex flex-wrap",
                      staticStyle: { "font-size": "16px" },
                      attrs: {
                        for: "lease_merge_" + _vm.product.id + "_" + date,
                      },
                    },
                    [
                      _c("span", { staticStyle: { "font-weight": "400" } }, [
                        _vm._v(_vm._s(date)),
                      ]),
                      _vm._v(
                        " - " +
                          _vm._s(_vm.getProgramText(date)) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _c(
          "label",
          {
            staticClass: "form-label font-weight-medium mb-2",
            attrs: { for: "customDate_" + _vm.product.id },
          },
          [
            _vm._v(
              _vm._s(
                _vm.getTranslation(
                  "licence-configurator",
                  "set_custom_end_date"
                )
              )
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control d-inline-block",
          staticStyle: { width: "200px", "font-size": "16px" },
          attrs: {
            type: "date",
            id: "customDate_" + _vm.product.id,
            min: _vm.leaseOptions.minDate,
            max: _vm.leaseOptions.maxDate,
            placeholder: "Select custom end date",
            disabled: _vm.leaseOptions.customdate === false,
          },
          domProps: { value: _vm.leaseOptions.customDate },
          on: {
            input: function ($event) {
              return _vm.selectCustomDate($event)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.hasCustomization()
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c("cart-info-prolong-customization", {
                attrs: { product: _vm.product },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }